import {listBoPhanMuaSam, listTrangThaiMuaSam} from "data/list";
import {formatDateToString, formatToCurrencyTypeToFixed} from "helper/common";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";

const {INPUT, CURRENCY, DATE, NUMBER, COMBO_BOX, AUTO_COMPLETE} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Nội dung",
    name: "tenDeNghi",
  },
  {
    type: AUTO_COMPLETE,
    label: "Bộ phận yêu cầu",
    name: "boPhan",
    options: listBoPhanMuaSam,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "trangThai",
    options: listTrangThaiMuaSam,
    // rules: [{required: true, message: "Chưa chọn kho nhập/đề nghị"}],
  },
];
const columns: any[] = [
  {
    dataIndex: "index",
    key: "index",
    width: 80,
    show: true,
    align: "center",
  },
  {
    dataIndex: "tenDeNghi",
    key: "tenDeNghi",
    title: "Tên đề nghị",
    align: "left",
    show: true,
    width: 250,
  },
  {
    dataIndex: "nguoiDeNghi",
    key: "nguoiDeNghi",
    title: "Người đề nghị",
    show: true,
    align: "left",
    width: 190,
  },
  {
    title: "Bộ phận",
    dataIndex: "boPhan",
    show: true,
    width: 120,
  },

  {
    dataIndex: "timeLine",
    key: "timeLine",
    title: "Ngày đề nghị",
    show: true,
    width: 120,
    align: "center",
    render: (value, record, index) => {
      return <>{formatDateToString(value, FORMAT_TIME.dayFull)}</>;
    },
  },
  {
    title: "Địa điểm",
    dataIndex: "diaDiem",
    show: true,
    width: 230,
    align: "center",
  },
  {
    title: "Tổng giá trị (VNĐ)",
    dataIndex: "tongTien",
    show: true,
    render: (value, record, index) => {
      return <>{formatToCurrencyTypeToFixed(value, 4)}</>;
    },
    align: "right",
    width: 150,
  },
  {
    dataIndex: "trangThaiStr",
    key: "trangThaiStr",
    title: "Trạng thái",
    align: "center",
    show: true,
    width: 250,
  },
  {
    dataIndex: "moTa",
    key: "moTa",
    title: "Nội dung",
    show: true,
    width: 150,
  },
  {
    dataIndex: "action",
    key: "action",

    align: "center",
    show: true,
    width: 150,
  },
];
export {fields, columns};
